module.exports = __webpack_public_path__ + "img/contact.a9cf584c.jpg";